import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import CruiseShipListContainer from './containers/CruiseShipListContainer';

const initialStateCruiseShipList = window.__INITIAL_STATE_IW_CRUISE_SHIP_LIST__;
delete window.__INITIAL_STATE_IW_CRUISE_SHIP_LIST__;
const cruiseShipListRoot = document.getElementById('iw-cruise-ship-list');

if (cruiseShipListRoot) {
  hydrateRoot(
    cruiseShipListRoot,
    <Globals
      siteId={initialStateCruiseShipList.siteId}
      legacyMode={initialStateCruiseShipList.legacyMode}
    >
      <CruiseShipListContainer
        cruiseShips={initialStateCruiseShipList.cruiseShips}
      />
    </Globals>,
  );
}
